<template>
  <van-popup
    :key="useFullscreenMode ? 'fullscreen' : 'default'"
    v-model="visible"
    :round="!useFullscreenMode"
    closeable
    :close-on-click-overlay="false"
    :position="useFullscreenMode ? 'center' : 'bottom'"
    :class="['question-popup', useFullscreenMode ? 'fullscreen-mode' : '']"
    :z-index="100001"
    :get-container="getContainer"
    :overlay-style="useFullscreenMode ? fullscreenOverlayStyle : null"
    @close="handleClose"
  >
    <QuestionContent
      v-if="visible"
      :question="question"
      :is-fullscreen="isFullscreen"
      @complete="handleComplete"
    />
  </van-popup>
</template>

<script>
import QuestionContent from './QuestionContent.vue'

export default {
  name: 'QuestionDialog',
  components: {
    QuestionContent
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: () => ({
        id: '',
        time: 0,
        title: '',
        options: [],
        answers: []
      })
    },
    isFullscreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      portalEl: null
    }
  },
  computed: {
    useFullscreenMode () {
      return this.isFullscreen
    },
    fullscreenOverlayStyle () {
      return {
        background: 'rgba(0, 0, 0, 0.65)'
      }
    }
  },
  watch: {
    show: {
      handler (val) {
        this.visible = val
      },
      immediate: true
    },
    useFullscreenMode (val, oldVal) {
      if (val === oldVal) return
      if (this.visible) {
        this.remountPopup()
      } else if (!val) {
        this.removePortal()
      }
    },
    visible (val) {
      if (!val) {
        this.$emit('update:show', false)
      }
      this.updatePortalPointerEvents()
    }
  },
  mounted () {
    if (this.useFullscreenMode) {
      this.ensurePortal()
      this.updatePortalPointerEvents()
    }
  },
  beforeDestroy () {
    this.removePortal()
  },
  methods: {
    getContainer () {
      // 全屏时挂载到播放器容器内，非全屏时挂载到 body
      if (this.useFullscreenMode) {
        const portal = this.ensurePortal()
        return portal || document.body
      }
      this.removePortal()
      return document.body
    },
    ensurePortal () {
      const playerRoot =
        document.querySelector('#dplayer .dplayer') ||
        document.getElementById('dplayer')
      if (!playerRoot) return null
      if (!this.portalEl) {
        this.portalEl = document.createElement('div')
        this.portalEl.className = 'question-dialog-portal'
        Object.assign(this.portalEl.style, {
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          zIndex: '100010',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        })
      }
      if (!playerRoot.contains(this.portalEl)) {
        playerRoot.appendChild(this.portalEl)
      }
      this.updatePortalPointerEvents()
      return this.portalEl
    },
    removePortal () {
      if (this.portalEl && this.portalEl.parentNode) {
        this.portalEl.parentNode.removeChild(this.portalEl)
      }
      this.portalEl = null
    },
    remountPopup () {
      this.visible = false
      this.$nextTick(() => {
        this.visible = true
      })
    },
    updatePortalPointerEvents () {
      if (this.portalEl) {
        this.portalEl.style.pointerEvents = this.visible ? 'auto' : 'none'
      }
    },
    handleComplete (result) {
      this.$emit('complete', result)
      this.handleClose()
    },
    handleClose () {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.question-popup {
  max-height: 80vh;
  overflow-y: auto;
}

.question-popup.fullscreen-mode {
  max-width: 520px;
  width: 90vw;
  max-height: 80vh;
  border-radius: 18px;
}

.question-popup.fullscreen-mode .question-popup__content {
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 18px;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.25);
}
</style>
